import { Injectable } from '@angular/core';
import { IAlert } from '../interfaces/alert';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  public alerts = Array<IAlert>();
  private alertSource = new Subject<IAlert>();
  public alert$ = this.alertSource.asObservable();

  /**
   * Cria um alerta na tela
   * alert
   * @param {string} message : mensagem a ser exibida
   * @param {string} type: tipo de mensagem [success, warning, danger, info]
   */
  public alert(
    message: string,
    type: 'success' | 'warning' | 'danger' | 'info' = 'info'
  ) {
    const newAlert: IAlert = {
      message: message,
      type: type,
    };

    this.alerts.push(newAlert);

    // Limitando a exibição de alertas para 6
    if (this.alerts && this.alerts.length === 6) {
      this.alerts.splice(0, 1);
    }

    if (newAlert.message.length > 50) {
      setTimeout(() => {
        this.removeAlert(newAlert);
      }, 7000);
    } else {
      setTimeout(() => {
        this.removeAlert(newAlert);
      }, 3500);
    }

    this.alertSource.next(newAlert);
  }

  public removeAlert(alert: IAlert) {
    const index = this.alerts.indexOf(alert);
    this.alerts.splice(index, 1);
  }
}
